import { useCallback, useState } from 'react'
import { CanalEnvio, PreferenciasEnvio, canaisMarcados, dadosDeEnvio } from '../core/montagem/envio'
import { sendPrescricao } from '../core/_requests'

/** O backend não devolve a entrega: "enviado" quer dizer que o pedido de envio foi aceito. */
export type EstadoCanal = 'enviando' | 'enviado' | 'falhou'

/** Envia os documentos assinados ao paciente e guarda o resultado de cada canal. */
export const useEnvioPaciente = () => {
  const [estados, setEstados] = useState<Partial<Record<CanalEnvio, EstadoCanal>>>({})
  const [preferencias, setPreferencias] = useState<PreferenciasEnvio>()

  const marcar = useCallback(
    (canais: CanalEnvio[], estado: EstadoCanal) =>
      setEstados((atuais) => ({
        ...atuais,
        ...Object.fromEntries(canais.map((canal) => [canal, estado])),
      })),
    []
  )

  const enviar = useCallback(
    async (
      ids: number[],
      prefs: PreferenciasEnvio,
      canais: CanalEnvio[] = canaisMarcados(prefs)
    ) => {
      setPreferencias(prefs)
      const dados = dadosDeEnvio(prefs, canais)
      if (!dados || ids.length === 0) return
      marcar(canais, 'enviando')
      try {
        for (const id of ids) await sendPrescricao(id, dados)
        marcar(canais, 'enviado')
      } catch {
        marcar(canais, 'falhou')
      }
    },
    [marcar]
  )

  const limpar = useCallback(() => {
    setEstados({})
    setPreferencias(undefined)
  }, [])

  return { estados, preferencias, enviar, limpar }
}
